import { ThumbsDown, ThumbsUp, X } from 'lucide-react'
import { useState } from 'react'

interface ConversationFeedbackProps {
  chatId: string
}

export function ConversationFeedback({ chatId }: ConversationFeedbackProps) {
  const storageKey = `conversationFeedbackDismissed_${chatId}`
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(storageKey) === 'true')
  const [rated, setRated] = useState(false)

  if (dismissed || rated) return null

  const handleRate = (value: 'up' | 'down') => {
    setRated(true)
    // TODO: POST to /api/v1/chat/{chatId}/feedback
    console.log('[Feedback] Conversation rated:', value)
  }

  const handleDismiss = () => {
    setDismissed(true)
    localStorage.setItem(storageKey, 'true')
  }

  return (
    <div className="flex items-center justify-center gap-3 py-2 px-3 mx-2 my-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
      <span className="text-xs text-muted-foreground">Is this conversation helpful so far?</span>
      <button
        type="button"
        onClick={() => handleRate('up')}
        className="p-1 rounded hover:bg-muted transition-colors"
      >
        <ThumbsUp className="h-3.5 w-3.5 text-muted-foreground" />
      </button>
      <button
        type="button"
        onClick={() => handleRate('down')}
        className="p-1 rounded hover:bg-muted transition-colors"
      >
        <ThumbsDown className="h-3.5 w-3.5 text-muted-foreground" />
      </button>
      <button
        type="button"
        onClick={handleDismiss}
        className="p-1 rounded hover:bg-muted transition-colors"
      >
        <X className="h-3.5 w-3.5 text-muted-foreground" />
      </button>
    </div>
  )
}
